import { FC, useState } from 'react'
import {
  Modal,
  Button,
  Typography,
  Divider,
  Box,
  TextField,
  Chip,
  Autocomplete,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'

interface Role {
  id: number
  name: string
  alias: string | null
  dateCreated: string
  dateModified: string
}

interface UserModalProps {
  open: boolean
  onClose: () => void
  onUpdate: (data: any) => void
  data?: any
  rolesData: Role[]
}

const StyledModal = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

const ModalContent = styled(Box)({
  width: 600,
  height: 300,
  backgroundColor: '#ffffff',
  borderRadius: 12,
  boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.1)',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
})

const ModalTitle = styled(Typography)({
  fontSize: '22px',
  fontWeight: 500,
  fontFamily: 'Gabarito',
  color: '#505470',
  marginLeft: 1,
})

const ActionButton = styled(Button)({
  textTransform: 'none',
})

const ButtonGroup = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 20,
  marginBottom: 20,
  marginRight: 15,
})

const ModalBody = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
})

export const UserManagementForm: FC<UserModalProps> = ({
  open,
  onClose,
  onUpdate,
  data,
  rolesData,
}) => {
  const [currentRole, setCurrentRole] = useState<string[]>(
    data?.roles?.map((role: Role) => role.name),
  )

  console.log('data here ', data)

  return (
    <StyledModal open={open} onClose={onClose}>
      <ModalContent>
        <Box display="flex" flexDirection="column" justifyContent="flex-start">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            marginLeft={2}
          >
            <ModalTitle>Update Role</ModalTitle>
            <Button
              onClick={onClose}
              style={{ color: '#000000' }}
              sx={{ width: 20, height: 20 }}
            >
              <CloseIcon />
            </Button>
          </Box>
          <Divider sx={{ my: 2, borderWidth: 2, color: '#B1B8BF' }} />
        </Box>

        <ModalBody sx={{ marginBottom: 3 }}>
          <Autocomplete
            disablePortal
            multiple
            options={rolesData || []}
            getOptionLabel={(option) => option.name}
            value={rolesData.filter((role) => currentRole?.includes(role.name))}
            onChange={(event, newValue) =>
              setCurrentRole(newValue.map((role) => role.name))
            }
            renderInput={(params) => (
              <TextField {...params} label="Roles" variant="outlined" />
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option.name}
                  {...getTagProps({ index })}
                />
              ))
            }
          />
        </ModalBody>

        <ButtonGroup>
          <ActionButton
            variant="outlined"
            sx={{
              borderColor: 'black',
              color: 'black',
              '&:hover': {
                borderColor: 'black',
                backgroundColor: 'rgba(0, 0, 0, 0.1)',
              },
            }}
            onClick={onClose}
          >
            Cancel
          </ActionButton>
          <ActionButton
            variant="contained"
            sx={{
              marginLeft: 2,
              backgroundColor: '#379F86',
              color: '#ffffff',
            }}
            onClick={() => onUpdate({ ...data, roles: currentRole })}
          >
            Update
          </ActionButton>
        </ButtonGroup>
      </ModalContent>
    </StyledModal>
  )
}
